window.CurrentDatetime = (function () {
    const timeNodeSelector = '#moscow_time';
    const initialFullMoscowTime = '#initial_full_moscow_time';
    const tickIntervalInSeconds = 5;
    var value = new Date();

    function setSeedValue() {
        var fullMoscowTime = $(initialFullMoscowTime).val();
        if (fullMoscowTime != undefined){
            var timeArray = fullMoscowTime.trim().split(':');
            if (timeArray.length == 3) {
                value.setUTCHours(timeArray[0]);
                value.setUTCMinutes(timeArray[1]);
                value.setUTCSeconds(timeArray[2]);
                return;
            }
        }
        $(timeNodeSelector).parent().hide();
        return;
    }

    function updateTime() {
        value.setUTCSeconds(value.getUTCSeconds() + tickIntervalInSeconds);
        app.CurrentDatetime.time = getCurrentTimeString(value);
    }

    function getCurrentTimeString(date) {
        return ('0' + date.getUTCHours()).slice(-2) + ':' + ('0' + date.getUTCMinutes()).slice(-2);
    }

    return {
        init: function () {
            var self = this;

            app.bindModelHtml(self, 'time', $(timeNodeSelector));

            setSeedValue();
            setInterval(updateTime, tickIntervalInSeconds * 1000);
        }
    };
}());